import { Controller, useFormContext } from 'react-hook-form';
import { RadioGroup, Box, RadioProps, SxProps, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomRadio from '../custom-radio/CustomRadio';
import BaseInputLabel from './BaseInputLabel';
import { parseBooleanString } from '../../utils/helpers';

interface IProps {
  name: string;
  label?: string;
  options?: Map<string | boolean, string>;
  required?: boolean;
  radio?: {
    sx?: SxProps<Theme>;
    config?: RadioProps;
    label: string;
  };
}

function ControlledRadioInput({ name, label, radio, required, options }: IProps) {
  const { control } = useFormContext();
  const { t } = useTranslation();
  return (
    <>
      {/* Input label */}
      {label && <BaseInputLabel text={label as string} required={required} />}
      {/* Render RadioGroup if the 'options' param passed. If not - render single RadioButton */}
      <Controller
        name={name}
        control={control}
        render={({ field }) =>
          options ? (
            <RadioGroup
              {...field}
              onChange={(e) => field.onChange(parseBooleanString(e.target.value))}
              name="row-radio-buttons-group"
            >
              <Box sx={{ display: 'flex' }}>
                {Array.from(options, ([key, value]) => (
                  <CustomRadio labelSx={{ marginRight: '32px' }} value={key} label={t(value)} />
                ))}
              </Box>
            </RadioGroup>
          ) : (
            <CustomRadio
              {...field}
              labelSx={radio?.sx}
              value={field.value}
              label={t(radio?.label as string)}
              radioProps={{
                ...radio?.config,
                onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                  field.onChange(parseBooleanString(e.target.value)),
              }}
            />
          )
        }
      />
    </>
  );
}

export default ControlledRadioInput;
